import CustomNavbar from "../../components/common/CustomNavbar";
import PageLayout from "../../components/layouts/PageLayout";
import { GalleryList } from "./GalleryList";
import ECSLoader from "../../components/common/EcsLoader";
import { useState } from "react";

export function Gallery() {
    const [isLoading, setIsLoading] = useState(false);

    return (
        <PageLayout customNavbar={
            <CustomNavbar>
                <div className="flex gap-3 items-center w-max">
                    <span className="font-bold text-lg uppercase">Gallery</span>
                </div>
            </CustomNavbar>
        }>
            <div className="rounded-4xl w-full bg-gray-100">
                <div className="flex flex-col rounded-4xl w-full p-4 bg-white min-h-screen relative overflow-hidden">
                    <ECSLoader show={isLoading} />
                    <GalleryList onLoadingChange={setIsLoading} />
                </div>
            </div>
        </PageLayout>
    );
}